import { Component, ElementRef, EventEmitter, Input, OnInit, Output, Renderer2, ViewChild, ViewEncapsulation } from '@angular/core';
import { UserLandingV2Item } from '../user-landings-v2-models';
import { MediaPictureService } from 'projects/common/services/media-picture.service';
import { trigger, transition, style, animate } from '@angular/animations';
import { TranslateService } from '@ngx-translate/core';
import { DropdownService } from '../dropdown.service';
import { Device } from 'projects/common/model/Device';
import { UpaService } from 'projects/common/services/upa.service';

@Component({
  selector: 'user-landings-card-v2',
  template: `
    <div class='{{typeView}}'>
      <div @fade (click)="navigateToUrl(this.data.landing_url)" class="eva-3-card user-landing-card" [ngClass]="{'old-purchase': data.old_purchase}">
        <img [src]="mediaService.getMediaUrl(data.main_picture, getImageSize())" alt="" loading="lazy" class="user-landings-card-picture" (error)="getDefaultImage($event)">
        <div class="user-landing-card-info">
          <div class="card-header">
            <h5 class="card-title eva-3-{{this.isDesktop ? 'h3' : 'h5'}}">{{data.title}}</h5>

            <button *ngIf="showMenu" name="" class="card-button-menu eva-3-btn -xsm -link" (click)="openMenu($event)">
              <i class="eva-3-icon-more-vertical -eva-3-icon-md btn-icon"></i>
            </button>

            <div *ngIf="isOpenMenu" class="card-menu" #dropdownMenu>
              <div *ngIf="!data.old_user_landing" class="menu-item" (click)="onUpdateClick($event, data)">
                <i class="eva-3-icon-edit -eva-3-icon-{{this.isDesktop ? 'md' : 'sm'}}"></i>
                <p class="menu-item-text eva-3-body-{{this.isDesktop ? '1' : '2'}}">{{'userLandings.btn.card.edit' | translate}}</p>
              </div>
              <div class="menu-item" (click)="onDeleteClick($event, data)">
                <i class="eva-3-icon-trash -eva-3-icon-{{this.isDesktop ? 'md' : 'sm'}}"></i>
                <p class="menu-item-text eva-3-body-{{this.isDesktop ? '1' : '2'}}">{{'userLandings.btn.card.delete' | translate}}</p>
              </div>
            </div>

          </div>
          <div class="stay-days-container" *ngIf="showStayDays && data.days">
            <i class="eva-3-icon-calendar -eva-3-icon-sm -eva-3-mr-xsm calendar-icon"></i>
            <p class="eva-3-body-2">{{ data.days }} {{ 'userLandings.card.days' | translate }}</p>
          </div>
          <p *ngIf="showDates && data.from_date && data.to_date" class="eva-3-{{this.isDesktop ? 'body-2' : 'caption'}} user-landing-card-date">{{data.from_date}} - {{data.to_date}}</p>
          <p *ngIf="showDates && !data.from_date && !data.to_date" class="eva-3-{{this.isDesktop ? 'body-2' : 'caption'}} user-landing-card-date">{{'userLandings.card.empty.days' | translate}}</p>
          <div *ngIf="showFavorites" class="eva-3-body-2 items-wrapper">
            <div class="favorites-container">
              <i class="eva-3-icon-favorite -eva-3-icon-{{this.isDesktop ? 'md' : 'sm'}}"></i>
              <p class="favorite-data"> {{resolveFavoriteText()}}</p>
            </div>
            <div *ngIf="data.purchases && !hidePurchase" class="purchases-container">
              <i class="eva-3-icon-bag -eva-3-icon-{{this.isDesktop ? 'md' : 'sm'}}"></i>
              <p class="purchase-number">{{data.purchases}}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  `,
  animations: [
    trigger('fade', [
      transition(':enter', [
        style({ opacity: 0 }),
        animate('500ms', style({ opacity: 1 })),
      ]),
      transition(':leave', [
        animate('500ms', style({ opacity: 0 }))
      ])
    ]),
  ],
  styleUrls: ['./user-landings-card-v2.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class UserLandingsCardV2Component implements OnInit {
  @Input() moduleId: string;
  @Input() uniqueId: string;
  @Input() moduleIndex: number;
  @Input() device: Device;
  @Input() data: UserLandingV2Item;
  @Input() upaData: any;
  @Input() typeView: 'horizontal' | 'vertical' = 'horizontal';
  @Input() showMenu: boolean = true;
  @Input() showFavorites: boolean = true;
  @Input() showDates: boolean = true
  @Input() showStayDays: boolean = false;
  @Input() hidePurchase: boolean = false;
  @Input() sizeImage: string;

  @Output() deleteEvent: EventEmitter<UserLandingV2Item> = new EventEmitter();
  @Output() updateEvent: EventEmitter<UserLandingV2Item> = new EventEmitter();

  @ViewChild('dropdownMenu') dropdownMenu: ElementRef;

  isOpenMenu: boolean = false;
  isDesktop: boolean = false;
  defaultMediaKey = '2a52c394-d52e-4896-903b-268f9a3a3578';

  constructor(
    public mediaService: MediaPictureService,
    private translateService: TranslateService,
    private renderer: Renderer2,
    private elementRef: ElementRef,
    private dropdownService: DropdownService,
    private upaService: UpaService
  ) { }

  ngOnInit(): void {
    this.isDesktop = this.device.type === "DESKTOP";
    // Escuchar clics fuera del componente para cerrar el dropdown
    this.renderer.listen('window', 'click', (event: Event) => {
      if (this.isOpenMenu && !this.elementRef.nativeElement.contains(event.target)) {
        this.isOpenMenu = false;
      }
    });
    // Suscribirse al estado del dropdown para cerrar el dropdown si se abre otro
    this.dropdownService.dropdownState$.subscribe((id: string) => {
      if (id !== this.data.id) {
        this.isOpenMenu = false;
      }
    });
  }

  resolveFavoriteText(): string {
    const { purchases, favorites } = this.data;

    if (purchases !== 0 && !this.hidePurchase) {
      return favorites.toString();
    }

    switch (favorites) {
      case 0:
        return this.translateService.instant('userLandings.card.empty.favorites');
      case 1:
        return this.translateService.instant('userLandings.card.one.favorites');
      default:
        return this.translateService.instant('userLandings.card.favorites', { favorites });
    }
  }

  getImageSize(): string {

    if (this.sizeImage) {
      return this.sizeImage;
    }

    if (this.typeView === 'vertical') {
      return '320x120'
    }
    return this.device.type === "DESKTOP" ? '320x120' : '92x76'
  }

  navigateToUrl(url: string): void {
    window.location.href = url;
  }

  openMenu(event: MouseEvent): void {
    event.stopPropagation();
    this.isOpenMenu = !this.isOpenMenu;
    if (this.isOpenMenu) {
      this.dropdownService.openDropdown(this.data.id);
      this.upaService.trackClickTopic({ ...this.upaData, label: 'OPEN_MENU', data: this.data });
    }
  }

  onDeleteClick($event, userLandingCard): void {
    $event.stopPropagation();
    $event.preventDefault();
    this.deleteEvent.emit(userLandingCard)
    this.upaService.trackClickTopic({ ...this.upaData, label: 'OPEN_DELETE_MODAL', data: this.data });
  }

  onUpdateClick($event, userLandingCard): void {
    $event.stopPropagation();
    $event.preventDefault();
    this.updateEvent.emit(userLandingCard)
    this.upaService.trackClickTopic({ ...this.upaData, label: 'OPEN_UPDATE_NAME_MODAL', data: this.data });
  }

  getDefaultImage(event: Event) {
    const imgElement = event.target as HTMLImageElement;
    imgElement.src = this.mediaService.getMediaUrl(this.defaultMediaKey, this.getImageSize())!;
  }

}
